import { createApi } from "@reduxjs/toolkit/query/react";
import { cacheDurationSeconds } from "common/constants";
import { baseQueryWithReauth } from "./utils/constants";
import {
	TransactionsParams,
	TransactionsResponse,
} from "./utils/interfaces";
import moment from "moment"; 

const getUrlParams = (args) => {
	const allowedParams = ["userName", "endTime", "limit", "startTime", "offset", "sortBy", "filterBy"];
	const queryParams: string[] = [];
	Object.keys(args).forEach(key => {
		if (allowedParams.includes(key) && args[key]) {
			queryParams.push(`${key}=` + args[key]);
		}
	});
	return queryParams.join("&");
};
// &currentTime=${moment(new Date()).format()}
export const teamApi = createApi({
	reducerPath: "team",
	baseQuery: baseQueryWithReauth,
	keepUnusedDataFor: cacheDurationSeconds,
	endpoints: (builder) => ({
		getTeam: builder.query<any, TransactionsParams>({
			query: (args) => ({
				url: `get-location-operators?${getUrlParams(args)}`,
			}),
		}),
		fefundTransaction: builder.mutation<void, any>({
			query: (data) => {
				const { transactionId, chargePointId } = data;
				return {
					url: `refund-transaction`,
					method: "PUT",
					body: { transactionId: transactionId, "locationId.stationId.chargePointId": chargePointId }
				};
			},
		}),
        createTeam: builder.mutation<any, any>({
			query: (data) => {
				return {
					url: `create-location-operator`,
					method: "PUT",
					body: data
				};
			},
		}),
        updateTeam: builder.mutation<any, any>({
			query: (data) => {
				return {
					url: `save-location-operator`,
					method: "PUT",
					body: data
				};
			},
		}),
        deteteTeam: builder.mutation<any, any>({
			query: (data) => {
				return {
					url: `delete-location-operator`,
					method: "PUT",
					body: data
				};
			},
		}),
	}),
});

export const {
	useGetTeamQuery,
	useFefundTransactionMutation,
    useCreateTeamMutation,
    useUpdateTeamMutation,
    useDeteteTeamMutation
} = teamApi;
